import { getUrlSearchParam } from "../pages/utils/commonUtils";
import useHttp from "./useHttp";

export default function useServices() {
  var rightServiceId = getUrlSearchParam("rightServiceId");

  var selectedIds = getUrlSearchParam("selectedIds");
  var resource = getUrlSearchParam("resource");

  const { fetchData } = useHttp();

  const getAllTextSMSServices = (appProperties) => {
    return new Promise((resolve, reject) => {
      const leftServiceId = appProperties?.leftServiceId || getUrlSearchParam("leftServiceId");
      if (!leftServiceId) {
        reject(new Error("Missing leftServiceId"));
        return;
      }
      fetchData(`omessage/apps?serviceId=${leftServiceId}`, "GET", null, appProperties)
        .then((data) => {
          let response = "";
          if (data) {
            response = JSON.parse(data);
            resolve(response);
          } else {
            resolve(null);
          }})
        .catch((error) => {
          reject(error);
        });
    });
  };

  const fetchInstalledServices = (appProperties) => {
    let path = window.location.pathname;
    var customWorkflow = "";
    if (path === "/zoho-crm/webhook") {
      customWorkflow = "custom-workflow";
    }
    var leftServiceId = getUrlSearchParam("leftServiceId");
    var companyId = getUrlSearchParam("companyId");
    var userId = getUrlSearchParam("userId");
    userId = appProperties?.userId ?? userId;
    companyId = appProperties.companyId ?? companyId;
    var targetUrl = `integrations?leftServiceId=${leftServiceId}&rightServiceId=${rightServiceId}&selectedIds=${selectedIds}&resource=${resource}&companyId=${companyId}&userId=${userId}&action=${customWorkflow}`;
    if (appProperties?.controller?.isEmbeddedApp) {
      if (path.includes("/dialpad")) {
        targetUrl += `&appType=VOICE`;
      } else if (path.includes("/sendsms")) {
        targetUrl += `&appType=MESSAGE`;
      }
    }
    return new Promise((resolve, reject) => {
      fetchData(targetUrl, "GET", null, appProperties)
        .then((response) => {
          let responseData = "";
          if (response) {
            responseData = JSON.parse(response);
          }
          resolve(responseData);
        })
        .catch((error) => {});
    });
  };

  return {
    getAllTextSMSServices,
    fetchInstalledServices,
  };
}
